<template>
    <div v-hotkey="keymap" class="run-button">
        <b-button
                block
                variant="primary"
                size="lg"
                @click="runNakdanClicked">{{ hebrew ? 'החל פיענוח' : 'Expand abbreviations' }}</b-button>
            <b-modal v-model="showTextTooLongPrompt"
                id="text-too-long-modal"
                size="sm"
                centered
                hide-header
                ok-only
                body-class="pr-0 pl-0"
                :ok-title="hebrew ? 'בסדר, הבנתי' : 'OK, I understand'"
                footer-class="text-too-long-footer"
                @ok="showTextTooLongPrompt = false">
        <p class="text-center mb-0">{{ hebrew ? 'אפשר להעלות טקסט של עד 10000 תווים' : 'Only up to 10000 characters may be submitted' }}</p>
        </b-modal>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {Actions} from '@/store/stateChanges'
    import serviceMixins from '@/mixins/serviceMixins'
    import {BlankState} from '@/store/stateParts'

    export default {
        name: 'NakdanRunner',
        props: ['options'],
        mixins: [serviceMixins], // for gtag()
        data() {
            return {
                showTextTooLongPrompt: false,
            }
        },
        computed: {
            hebrew () {
                return this.$settings.hebrew
            },            
            keymap: function () {
                return {
                    'ctrl+enter': this.runNakdanClicked
                }
            }
        },
        methods: {
            runNakdanClicked() {
                if (this.$store.state.originalDocument.text.length) {
                    var textIsJson
                    try {
                        textIsJson = JSON.parse(this.$store.state.originalDocument.text)
                    } catch { /* this comment's just so it's not an 'empty block' */ }
                    if (this.$store.state.originalDocument.text.length > 10000 && !textIsJson) {
                        this.showTextTooLongPrompt = true
                    } else {
                        const nonDefaultOptions = Object.keys(BlankState.preSubmissionOptions).filter(
                            k => this.options[k] !== BlankState.preSubmissionOptions[k]
                        ).map(k => k + ': ' + this.options[k])
                        this.gtag("event", "options for nikud set", {
                            'event_category': 'user input',
                            'event_label': 'non-default options: ' + (
                                nonDefaultOptions.length ? nonDefaultOptions.join(', ') : 'none')
                        })
                        this.$store.commit('STORE_ALL_PRE_SUBMISSION_OPTIONS', this.options)
                        this.$store.commit('SET_TEXT_FOR_NAKDAN_API_CALL', this.$store.state.originalDocument.text)
                        this.$store.dispatch(Actions.RUN_NAKDAN)
                    }
                }
            }
        }
    }
</script>

<style scoped>
    /* DocumentSettings-specific CSS goes here */
    .run-button {
        display: block;
        margin: 18px 14px 15px;
    }
</style>
